export function setupNavBackdrop() {
  const nav = document.querySelector<HTMLElement>('.s-nav');
  if (!nav) return;
  const update = () => {
    nav.dataset.scrolled = window.scrollY > 80 ? '1' : '0';
  };
  window.addEventListener('scroll', update, { passive: true });
  update();
}
